module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ca-AD.json
// module id = 1466
// module chunks = 22